import React from 'react';
import Select from './common/Select';
import {languageOptions,validNumberRegex} from '../utils/constants';
import NumberInput from './common/NumberInput';
import PlainButton from './common/PlainButton';
import Mathjax from './common/Mathjax';
import Toggle from 'react-toggle'
import { DropdownIndicator } from '../utils/dropdown-override';
import ToolTip from './common/ToolTip';
import SetFontSizeComponent from './common/SetFontSizeComponent.jsx';
import SetCaseMenuSizeComponent from './common/SetCaseMenuSizeComponent.jsx';
import RangeFilterComponent from './attribute/range/RangeFilterComponent';

class PlotSettingComponent extends React.Component {
    constructor(props) {
        super(props);

        var attributeOptions = [],
            orderByAttribute = this.props.Dyn.dataSet.getOrderByAttribute(),
            selectedByAttribute = this.props.Dyn.dataSet.getSelectedAttribute();

        this.updateXYAxisDelay = '';

        if (orderByAttribute)
            orderByAttribute = orderByAttribute.id;
        if (selectedByAttribute)
            selectedByAttribute = selectedByAttribute.id;

        //loop thru the attributes, to get value, lable pair dict
        this.props.Dyn.dataSet.attribs.map(function(item, i) {
            attributeOptions.push({ value: item.id, label: item.name });
        }.bind(this));

        this.state = {
            attributeOptions: attributeOptions,
            orderByAttribute: orderByAttribute,
            selectedByAttribute: selectedByAttribute,
            gridLines : this.props.Dyn.preferences.isGridLinesOn(),
            wantY2Axis : this.props.Dyn.preferences.wantY2Axis(),
            language : this.props.language,
            labels: this.props.Dyn.preferences.isStatsLabelOn(),
            isCustomIconOn: this.props.Dyn.plotView.plotShaper.iconStyler.isCustomCaseIconEnabled(),
            axisData : {
                rangeX : {
                    min: this.props.Dyn.plotView.xAxis.getNumericAxisRange().min,
                    max : this.props.Dyn.plotView.xAxis.getNumericAxisRange().max
                },
                rangeY : {
                    min:  this.props.Dyn.plotView.yAxis.getNumericAxisRange().min,
                    max :  this.props.Dyn.plotView.yAxis.getNumericAxisRange().max
                },
                rangeY2 : {
                    min:  this.props.Dyn.plotView.y2Axis? this.props.Dyn.plotView.y2Axis.getNumericAxisRange().min: 0,
                    max :  this.props.Dyn.plotView.y2Axis? this.props.Dyn.plotView.y2Axis.getNumericAxisRange().max: 0
                }
            }
        }
        // this.props.Dyn.plotView.plotShaper.showLabelsOnStats,
    }

    onKeyPressed = (e) => {
        if(e.keyCode === 27) {
            // Focus close button on esc
            this.refs.closeButton.focus();
        }
    }
    handleClose = (event) => {
        // To close the current view
        this.props.onClose();
    }
    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str );
    }
    changeHandler = (obj) => {
       this.setState({
            language : obj.value
        });
        this.props.switchLanguage( obj.value );
    }

    changeSelectedByAttribute = (obj) => {
        var attrObj = this.props.Dyn.dataSet.getAttributeByID(obj.value);
        if(this.props.onAttributeNameSelected) {
            this.props.onAttributeNameSelected(attrObj);
        }
        this.setState({
            selectedByAttribute : obj.value
        });
    }

    changeOrderByAttribute = (obj) => {
        var attrObj = this.props.Dyn.dataSet.getAttributeByID(obj.value);
        if(this.props.onOrderByAttributeSelected) {
            this.props.onOrderByAttributeSelected(attrObj);
        }
        this.setState({
            orderByAttribute : obj.value
        });
    }


    handleClickGridLines= ( value ) => {
        if (value !== this.state.gridLines) {
            this.setState({
                gridLines : value
            }, () => this.props.Dyn.preferences.setGridLinesOn(value));
        }
    }

    handleClickLabels = ( value ) => {
        if (value !== this.state.labels) {
            this.setState({
                labels: value
            }, () => this.props.Dyn.preferences.setStatsLabelOn(value) );
        }
    }

    handleClickDualAxis = ( value ) => {
        if (value !== this.state.wantY2Axis) {
            this.setState({
                wantY2Axis: value
            }, () => this.props.Dyn.preferences.setWantY2Axis(value) );
        }
    }

    handleClickCustomIcon = ( value ) => {
        if (value !== this.state.isCustomIconOn) {
            this.setState({
                isCustomIconOn: value
            }, () => this.props.Dyn.preferences.setCustomIconOn(value) );
        }
    }

    updateAxisValue = (value, axis) => {
        validNumberRegex.test(value[0]) && validNumberRegex.test(value[1]) && this.setState({
            axisData : {
                rangeX : {
                    min: axis == 'x'? value[0] : this.state.axisData.rangeX.min,
                    max: axis == 'x'? value[1] : this.state.axisData.rangeX.max
                },
                rangeY : {
                    min: axis == 'y'? value[0] : this.state.axisData.rangeY.min,
                    max: axis == 'y'? value[1] : this.state.axisData.rangeY.max
                },
                rangeY2 : this.state.wantY2Axis ? {
                    min: axis == 'y2'? value[0] : this.state.axisData.rangeY2.min,
                    max: axis == 'y2'? value[1] : this.state.axisData.rangeY2.max
                } : {}
            }
        },this.updateXYAxis);
    }

    updateXYAxis = () => {
        clearTimeout(this.updateXYAxisDelay);
        this.updateXYAxisDelay = setTimeout(() => {
            this.props.Dyn.mediator.publish("axis:setMinMax", this.state.axisData)
        }, 1000);
    }

    componentDidMount = () => {
        let Dyn = this.props.Dyn;
        this.subscriptions = [];

        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:modelUpdated", ( data ) => {
            // let xAxisDecimals = 0,yAxisDecimals = 0, y2AxisDecimals = 0;
            // Dyn.plotView.xAxis.allAttributes.attributes.map(atts => {
            //     if(atts.getNumericDecimals() > xAxisDecimals){
            //         xAxisDecimals = atts.getNumericDecimals();
            //     }
            // });
            // Dyn.plotView.yAxis.allAttributes.attributes.map(atts => {
            //     if(atts.getNumericDecimals() > yAxisDecimals){
            //         yAxisDecimals = atts.getNumericDecimals();
            //     }
            // });
            // if(Dyn.plotView.y2Axis) {
            //     Dyn.plotView.y2Axis.allAttributes.attributes.map(atts => {
            //         if(atts.getNumericDecimals() > y2AxisDecimals){
            //             y2AxisDecimals = atts.getNumericDecimals();
            //         }
            //     });
            // }

            let axisData = {
                rangeX : {
                    min: this.props.Dyn.plotView.xAxis.getNumericAxisRange().min || 0,
                    max : this.props.Dyn.plotView.xAxis.getNumericAxisRange().max || 0
                },
                rangeY : {
                    min:  this.props.Dyn.plotView.yAxis.getNumericAxisRange().min || 0,
                    max :  this.props.Dyn.plotView.yAxis.getNumericAxisRange().max || 0
                }
            };
            if(this.props.Dyn.plotView.y2Axis) {
                axisData.rangeY2 = {
                    min:  this.props.Dyn.plotView.y2Axis.getNumericAxisRange().min || 0,
                    max :  this.props.Dyn.plotView.y2Axis.getNumericAxisRange().max || 0
                };
            };

            this.setState({
                axisData,
                labels : Dyn.preferences.isStatsLabelOn(),
                gridLines : this.props.Dyn.preferences.isGridLinesOn(),
                wantY2Axis : this.props.Dyn.preferences.wantY2Axis()
            });
        });
        // Focus the panel
        this.refs.plotSettingPanel.focus();
    }

    componentWillUnmount() {
       this.props.Dyn.mediatorLocalRemoveAll( this.subscriptions );
    }


    render = () => {
        // TODO: This check can be ignored when the plotview including casecard and table views are destroyed when switching to play view
        if(!this.props.Dyn.plotView || !this.props.Dyn.plotView.plotShaper) {
            return <></>;
        }
        function isAxisNumerical( axisView ) {
            return Boolean(
                axisView // axis view must exist
                && axisView.isNumericalScaleAxis() // must have a visible scale
                && (typeof axisView.getNumericAxisRange().min !== "undefined")); // and a numeric min value
        }
        let isXNumerical = isAxisNumerical( this.props.Dyn.plotView.xAxis );
        let isYNumerical = isAxisNumerical( this.props.Dyn.plotView.yAxis );
        let isY2Numerical = isAxisNumerical( this.props.Dyn.plotView.y2Axis );
        let xAxisFirstAttribute = isXNumerical? this.props.Dyn.plotView.xAxis.allAttributes.attributes[0] : null;
        let yAxisFirstAttribute = isYNumerical? this.props.Dyn.plotView.yAxis.allAttributes.attributes[0]: null;
        let y2AxisFirstAttribute = isY2Numerical? this.props.Dyn.plotView.y2Axis.allAttributes.attributes[0]: null;
        let isCustomeOrderByAllowed = this.props.Dyn.plotView.plotShaper.allowCustomOrderBy();
        let orderByTitle = this.props.Dyn.plotView.plotShaper.isCustomOrderForLines() ? 'Order Lines By' : 'Order Cases By';
        let hasCustomIcon = this.props.Dyn.plotView.plotShaper.iconStyler.hasCustomCaseIcon();
        let mode = this.props.mode || 'default';

        return (
        <div className="tde-fill" ref="plotSettingPanel" onKeyDown={this.onKeyPressed} tabIndex="0" style={this.props.style}>
            <div className="tde-sliding-panel-header tde-divider-bottom">
                <div>
                    <span
                        className="tde-ml-2 tde-h6 tde-font-weight-bold"
                        role="heading"
                        aria-level="1">{ this.getLoc('PLOT SETTINGS CARD') }</span>
                </div>
                <PlainButton title="Close" ref="closeButton" aria-label={this.getLoc('Close Plot Settings Card')} onClick={this.handleClose} className="tde-mx-2 tde-close-attr-settings"><i className="tde-i tde-i-remove"></i></PlainButton>
            </div>
            <div className="tde-sliding-panel-body tde-plot-settings-body tde-card-content-bg-color tde-pt-2">
                <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                    <div className="tde-my-2 tde-s1-size tde-align-center tde-d-flex">
                        <p className="tde-label tde-flex-1 tde-font-weight-bold">{ this.getLoc('Color Cases By') }<ToolTip tip={this.getLoc('Color cases by selected attribute')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip></p></div>
                    <div className="tde-s1-size tde-align-center tde-d-flex">
                        <Select
                            id="tde-case-color-select"
                            Dyn={this.props.Dyn}
                            aria-label={this.getLoc('Color cases by selected attribute')}
                            className="tde-input tde-flex-1 tde-select-input tde-input-select tde-color-case"
                            isClearable={false}
                            value={this.state.attributeOptions.find(obj => obj.value === this.state.selectedByAttribute) }
                            options={this.state.attributeOptions}
                            // openMenuOnFocus
                            isSearchable={false}
                            tabSelectsValue={false}
                            placeholder={<div className='tde-select-placeholder'>{this.getLoc('Select')+'...'}</div>}
                            onChange={this.changeSelectedByAttribute}
                            components={{
                                Option: ({ data, innerProps, children,innerRef,isSelected,isFocused }) => (
                                    <div className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')} title={data.title} {...innerProps} ref={innerRef}>
                                        <div className="tde-s1"><Mathjax value={children} /></div>
                                    </div>
                                ),
                                DropdownIndicator
                            }}
                        />
                    </div>

                {isCustomeOrderByAllowed && <div>
                    <div className="tde-align-center tde-s1-size tde-d-flex tde-mt-3 tde-mb-2">
                    <p className="tde-label tde-fill tde-font-weight-bold">{ this.getLoc(orderByTitle) }<ToolTip tip={this.getLoc('Order cases by selected attribute')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip></p></div>
                    <div className="tde-s1-size tde-align-center tde-d-flex">
                    <Select
                        id="tde-case-order-select"
                        Dyn={this.props.Dyn}
                        aria-label={this.getLoc('Order Cases By')}
                        className="tde-input tde-flex-1 tde-select-input tde-input-select tde-order-case"
                        isClearable={false}
                        value={this.state.attributeOptions.find(obj => obj.value === this.state.orderByAttribute) }
                        options={this.state.attributeOptions}
                        // openMenuOnFocus
                        isSearchable={false}
                        tabSelectsValue={false}
                        onChange={this.changeOrderByAttribute}
                        placeholder={<div className='tde-select-placeholder'>{this.getLoc('Select')+'...'}</div>}
                        components={{
                            Option: ({ data, innerProps, children,innerRef,isSelected,isFocused }) => (
                                <div className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')} title={data.title} {...innerProps} ref={innerRef}>
                                    <div className="tde-s1"><Mathjax value={children} /></div>
                                </div>
                            ),
                            DropdownIndicator
                        }}
                    />
                </div>
            </div>}

                {isXNumerical && xAxisFirstAttribute && <div className="tde-mt-3 tde-s1-size tde-minmax-input">
                    <p className="tde-font-weight-bold tde-label tde-fill">{ this.getLoc('X-Axis Range') }</p>
                    <RangeFilterComponent
                        min={this.state.axisData.rangeX.min}
                        max={this.state.axisData.rangeX.max}
                        Dyn={this.props.Dyn}
                        type={xAxisFirstAttribute.getDataType(true)}
                        attributeObj={xAxisFirstAttribute}
                        label={this.getLoc('X-Axis Range')}
                        onChange={value => this.updateAxisValue(value,'x')}
                    />
                    {/* <div className="tde-d-flex tde-mt-2">
                        <div className="">
                            <p className="tde-mt-0 tde-mb-1">{this.getLoc('Min')}</p>
                            <NumberInput value={this.state.axisData.rangeX.min} onChange={value => this.updateAxisValue(value,'Xmin')} />
                        </div>
                        <div className="tde-ml-3">
                            <p className="tde-mt-0 tde-mb-1">{this.getLoc('Max')}</p>
                            <NumberInput value={this.state.axisData.rangeX.max} onChange={value => this.updateAxisValue(value,'Xmax')} />
                        </div>
                    </div> */}
                </div>}

                {isYNumerical && yAxisFirstAttribute && <div className="tde-mt-3 tde-s1-size tde-minmax-input">
                    <p className="tde-font-weight-bold tde-label tde-fill">{ isY2Numerical ? this.getLoc('Y1-Axis Range') : this.getLoc('Y-Axis Range')}</p>
                    <RangeFilterComponent
                        min={this.state.axisData.rangeY.min}
                        max={this.state.axisData.rangeY.max}
                        Dyn={this.props.Dyn}
                        type={yAxisFirstAttribute.getDataType(true)}
                        attributeObj={yAxisFirstAttribute}
                        label={isY2Numerical ? this.getLoc('Y1-Axis Range') : this.getLoc('Y-Axis Range')}
                        onChange={value => this.updateAxisValue(value,'y')}
                    />
                    {/* <div className="tde-d-flex tde-mt-2">
                        <div className="">
                            <p className="tde-mt-0 tde-mb-1">{this.getLoc('Min')}</p>
                            <NumberInput value={this.state.axisData.rangeY.min} onChange={value => this.updateAxisValue(value,'Ymin')} />
                        </div>
                        <div className="tde-ml-3">
                            <p className="tde-mt-0 tde-mb-1">{this.getLoc('Max')}</p>
                            <NumberInput value={this.state.axisData.rangeY.max} onChange={value => this.updateAxisValue(value,'Ymax')} />
                        </div>
                    </div> */}
                </div>}

                {isY2Numerical && y2AxisFirstAttribute && <div className="tde-mt-3 tde-s1-size tde-minmax-input">
                    <p className="tde-font-weight-bold tde-label tde-fill">{ this.getLoc('Y2-Axis Range') }</p>
                    <RangeFilterComponent
                        min={this.state.axisData.rangeY2.min}
                        max={this.state.axisData.rangeY2.max}
                        Dyn={this.props.Dyn}
                        type={y2AxisFirstAttribute.getDataType(true)}
                        attributeObj={y2AxisFirstAttribute}
                        label={this.getLoc('Y2-Axis Range')}
                        onChange={value => this.updateAxisValue(value,'y2')}
                    />
                    {/* <div className="tde-d-flex tde-mt-2">
                        <div className="">
                            <p className="tde-mt-0 tde-mb-1">{this.getLoc('Min')}</p>
                            <NumberInput value={this.state.axisData.rangeY2.min} onChange={value => this.updateAxisValue(value,'Y2min')} />
                        </div>
                        <div className="tde-ml-3">
                            <p className="tde-mt-0 tde-mb-1">{this.getLoc('Max')}</p>
                            <NumberInput value={this.state.axisData.rangeY2.max} onChange={value => this.updateAxisValue(value,'Y2max')} />
                        </div>
                    </div> */}
                </div>}
            </div>

                {/* For Dual Axis */}
                <div className='tde-divider-top tde-mt-4'>
                    <div className={(this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3') + ' tde-py-4'}>
                    {!['elem', 'jr'].includes(mode) && <div className="tde-s1-size tde-d-flex tde-align-center tde-mb-3">
                            <p className="tde-label tde-flex-1 tde-font-weight-bold">{ this.getLoc('Dual Axis') }<ToolTip tip={this.getLoc('Add second y-axis to scatter plot or line plot')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip></p>
                                <Toggle
                                    checked={this.state.wantY2Axis}
                                    className='black-toggle'
                                    icons={false}
                                    aria-label={this.getLoc('Toggle the second y-axis for the scatter plot or line plot')}
                                    onChange={e => {
                                        this.handleClickDualAxis(e.target.checked)
                                    }} />

                        </div>}
                        <div className="tde-s1-size tde-d-flex tde-align-center">
                            <p className="tde-label tde-flex-1 tde-font-weight-bold">{ this.getLoc('Grid Lines') }<ToolTip tip={this.getLoc('Add gridlines to the plotting area')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip></p>
                                <Toggle
                                    checked={this.state.gridLines}
                                    className='black-toggle'
                                    icons={false}
                                    aria-label={this.getLoc('Toggle gridlines in the plotting area')}
                                    onChange={e => {
                                        this.handleClickGridLines(e.target.checked)
                                    }} />
                        </div>
                        <div className="tde-s1-size tde-d-flex tde-align-center tde-mt-3">
                            <p className="tde-label tde-flex-1 tde-font-weight-bold">{ this.getLoc('Labels') }<ToolTip tip={this.getLoc('Add labels in the plotting area')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip></p>
                                <Toggle
                                    checked={this.state.labels}
                                    className='black-toggle'
                                    icons={false}
                                    aria-label={this.getLoc('Toggle the statistical labels in the plotting area')}
                                    onChange={e => {
                                        this.handleClickLabels(e.target.checked)
                                    }} />
                        </div>
                    </div>
                </div>
                <div className='tde-divider-top tde-mb-3'></div>
                <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                    <div className="tde-align-center tde-s1-size tde-d-flex tde-mt-4">
                        <p className="tde-label tde-fill tde-font-weight-bold tde-pb-2">{ this.getLoc('Language') }<ToolTip tip={'Change Language for Tuva Tools Interface'} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1"></i></ToolTip></p></div>
                    <div className="tde-s1-size tde-align-center tde-d-flex">
                        <Select
                            id="tde-case-language-select"
                            Dyn={this.props.Dyn}
                            aria-label={'Change Language for Tuva Tools Interface'}
                            menuPlacement="top"
                            className="tde-input tde-flex-1 tde-select-input tde-input-select"
                            isClearable={false}
                            value={{
                                label : languageOptions.find(obj => obj.value === this.state.language).label,
                                value : this.state.language
                            }}
                            options={languageOptions}
                            // openMenuOnFocus
                            isSearchable={false}
                            tabSelectsValue={false}
                            onChange={this.changeHandler}
                            placeholder={<div className='tde-select-option'>{this.getLoc('Select')+'...'}</div>}
                            components={{
                                Option: ({ data, innerProps, children,innerRef,isSelected,isFocused }) => (
                                    <div className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')} title={data.title} {...innerProps} ref={innerRef}>
                                        <div className="tde-s1">{children}</div>
                                    </div>
                                ),
                                DropdownIndicator
                            }}
                        />
                    </div>
                    <div className="tde-align-center tde-s1-size tde-d-flex tde-mt-4">
                    <p className="tde-label tde-fill tde-font-weight-bold tde-pb-2">{ this.getLoc('Font Size') }</p></div>
                    <SetFontSizeComponent reduceCaseCardWidth={this.props.reduceCaseCardWidth} getLoc={this.getLoc} Dyn={this.props.Dyn}/>
                    <div className="tde-align-center tde-s1-size tde-d-flex tde-mt-4">
                    <p className="tde-label tde-fill tde-font-weight-bold tde-pb-2">{ this.getLoc('Case Size') }</p></div>
                    <SetCaseMenuSizeComponent reduceCaseCardWidth={this.props.reduceCaseCardWidth} getLoc={this.getLoc} Dyn={this.props.Dyn}/>
                </div>

                {hasCustomIcon && <div className="tde-pb-4 tde-mt-4 tde-divider-bottom">
                    <div className={"tde-s1-size tde-d-flex tde-align-center" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
                            <p className="tde-flex-1 tde-label tde-font-weight-bold">{ this.getLoc('Custom Case Icon') }</p>
                                <Toggle
                                    checked={this.state.isCustomIconOn}
                                    className='black-toggle'
                                    icons={false}
                                    onChange={e => {
                                        this.handleClickCustomIcon(e.target.checked)
                                    }} />
                        </div>
                </div>}

                <div className="tde-mb-6"></div>
                </div>
            </div>
        );
    }
}

export default PlotSettingComponent
